





























































































































































































































































import dayjs from 'dayjs';
import * as R from 'ramda';
import { v4 as uuidv4 } from 'uuid';
import VueI18n from 'vue-i18n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { JobExecutionStatus } from '../../components/organisms/EventCalendarPanel.vue';
import { ScheduledEventHistoryForFront } from '../../types/type';
import { toLocaleDatetimeString } from '../globals/Util';
import { HolidayExecutionType, RepeatType } from '@/API';
import { changeTodayScheduledEvents } from '@/appsync/lambda/eventMetadataService';
import {
  fetchScheduledEventHistoryByFocusDateAndMetadataId,
  fetchScheduledEventMetadata,
  fetchScheduledHolidayMetadataLabels,
} from '@/appsync/service/EventCalendarQueryService';
import { fetchJobs } from '@/appsync/service/JobQueryService';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';
import HolidaySettingCard from '@/components/organisms/HolidaySettingCard.vue';
import ScheduleSettingCard from '@/components/organisms/ScheduleSettingCard.vue';
import UpdateHistoryInfo from '@/components/organisms/UpdateHistoryInfo.vue';
import WarningOnAccessFromIosDialog from '@/components/organisms/WarningOnAccessFromIosDialog.vue';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { commonModule } from '@/store/modules/CommonStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import {
  LoginInfo,
  JobIdAndTitle,
  ScheduledEventMetadataWithDetailForFront,
  UserInfo,
} from '@/types/type';
import {
  getDisabledRoutes,
  isEmptyArray,
  getTimezoneOffset,
  isAccessedFromIosDeviceOrSafariBrowser,
} from '@/utils/CommonUtils';
import {
  callCreateScheduledEventMetadata,
  callUpdateScheduledEventMetadata,
  endScheduleToday,
  isDateFromAfterToday,
  updateDateFromForCurrentEventMetadata,
} from '@/utils/EventCalendarUtils';
import { isRelatedToToday } from '@/utils/EventUtils';
import { isJobTitleMatching } from '@/utils/JobUtils';
import { newPortalDate } from '@/utils/PortalDate';
import { getRRuleSet, getRRuleSetArgs } from '@/utils/RRuleUtils';
import {
  AvailableActions,
  UserAction,
  PageType,
  PAGE_PATH_BY_NAME,
  SNACKBAR_TIMEOUT,
  PUBLIC_HOLIDAY,
  TriggerOnHolidays,
  INFINITE_DATE,
  JST_OFFSET_MINS,
} from '@/utils/consts';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  components: {
    PortalAppBar,
    PageNotFound,
    ErrorMessagePageTemplate,
    ScheduleSettingCard,
    HolidaySettingCard,
    UpdateHistoryInfo,
    WarningOnAccessFromIosDialog,
  },
})
export default class EventCalendarEvent extends Vue {
  @Prop({ required: false, default: false })
  private isReadOnly!: boolean;
  private fromRoute: string = '';

  private loading: boolean = true;
  private isJobSchedulerEnabled: boolean = false;
  private loginInfo!: LoginInfo;
  private hasSchedulerPermission: boolean = false;

  private notEnabledImgAltMessage: String = 'Page Not Enabled';
  private notEnabledImgName: String = 'page-not-enabled';
  private notEnabledImgWidth: String = '250px';
  private notEnabledImgHeight: String = '186px';

  private jobIdAndTitles: JobIdAndTitle[] = [];

  private isJobSelected: boolean = false;

  private isSaved: boolean = false;
  private isAborted: boolean = false;
  private snackbarTimeout: number = SNACKBAR_TIMEOUT;

  private eventNotFound: boolean = false;

  private pageType: PageType = PageType.create;
  private userAction: UserAction = UserAction.Cancel;

  private showingConfirmationDialog: boolean = false;
  private isAccessingFromJST: boolean = false;

  private existingLabels: string[] = [];
  private dbEventMetadata: ScheduledEventMetadataWithDetailForFront | null = null;
  private eventHistory!: ScheduledEventHistoryForFront | null;
  private hasErrorInScheduledSettingCard: boolean = false;
  private hasErrorInHolidaySettingCard: boolean = false;
  private showAccessFromIosOrSafariWarningDialog: boolean = false;

  private get moreActions() {
    return [
      {
        text: i18n.tc('jobScheduler.common.abortAndDelete'),
        value: AvailableActions.Abort,
        tooltipText: i18n.tc('jobScheduler.events.abortTooltip'),
        enableCondition: this.isEditPage,
      },
    ];
  }

  private get enabledMoreActions() {
    return this.moreActions.filter(action => action.enableCondition);
  }

  private currentEventMetadata: ScheduledEventMetadataWithDetailForFront = {
    id: uuidv4(),
    title: '',
    description: '',
    repeatType: RepeatType.NoRepeat,
    rruleSet: '',
    holidayExecutionType: HolidayExecutionType.NoChange,
    triggerOnHolidays: TriggerOnHolidays.allHolidays,
    customHolidayLabels: [],
    job: null,
    selectedDays: [],
    selectedWeekdays: [],
    dateFrom: null,
    dateTo: null,
    executionTime: '',
    updatedBy: '',
  };

  public async beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      vm.fromRoute = from.path;
      next();
    });
  }

  public async created(): Promise<void> {
    this.loginInfo = commonModule.loginInfo;
    await refreshStores(this.loginInfo);
    this.hasSchedulerPermission = (this as any).$hasPermission(
      'menus.scheduler'
    );

    const disabledRoutes = await getDisabledRoutes(
      this.loginInfo.tenant,
      this.loginInfo.landscape,
      this.loginInfo.loginName
    );

    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.eventCalendar)) {
      this.isJobSchedulerEnabled = true;

      const isAccessedFromNotRecommendedEnv: boolean = isAccessedFromIosDeviceOrSafariBrowser();
      if (isAccessedFromNotRecommendedEnv) {
        this.showAccessFromIosOrSafariWarningDialog = true;
      }

      this.isAccessingFromJST =
        new Date().getTimezoneOffset() === JST_OFFSET_MINS;

      this.existingLabels = await fetchScheduledHolidayMetadataLabels(
        this.loginInfo.tenant,
        this.loginInfo.landscape
      );
      this.existingLabels.unshift(PUBLIC_HOLIDAY);
      const eventId: string | null = this.$route.params.id as string | null;
      const path: string = this.$route.matched[0].path;

      if (eventId) {
        const eventMetadata = await fetchScheduledEventMetadata(
          this.loginInfo.tenant,
          this.loginInfo.landscape,
          eventId
        );
        this.pageCreateOnEventIdInUrl(eventMetadata, path);

        if (eventMetadata && eventMetadata.dateFrom) {
          const eventHistory = await fetchScheduledEventHistoryByFocusDateAndMetadataId(
            this.loginInfo.tenant,
            this.loginInfo.landscape,
            newPortalDate(new Date(`${eventMetadata.dateFrom} 00:00:00`)),
            eventMetadata.id
          );
          this.eventHistory = eventHistory;
        }
      } else {
        this.pageCreateOnNoEventIdInUrl(path);
      }

      const jobs = await fetchJobs(
        this.loginInfo.tenant,
        this.loginInfo.landscape
      );
      this.jobIdAndTitles = R.map(R.pick(['title', 'id']))(jobs);
    }
    this.loading = false;
  }

  private get formattedEventEnd(): string {
    if (!this.eventHistory || this.isNotTriggered) {
      return '-';
    }

    const status = this.eventHistory.jobExecutionStatus;
    const updatedAt = this.eventHistory.updatedAt;
    return updatedAt && status !== JobExecutionStatus.Running
      ? toLocaleDatetimeString(updatedAt)
      : '-';
  }

  private get isNotTriggered() {
    return (
      this.eventHistory &&
      this.eventHistory.jobExecutionStatus === JobExecutionStatus.NotTriggered
    );
  }

  private get pageTitle() {
    switch (this.pageType) {
      case PageType.edit:
        return this.$t('jobScheduler.events.updateEventTitle');
      case PageType.copy:
        return this.$t('jobScheduler.events.copyEventTitle');
      case PageType.view:
        return this.$t('jobScheduler.events.viewEventTitle');
      case PageType.create:
        return this.$t('jobScheduler.events.createEventTitle');
      default:
        return this.$t('jobScheduler.events.createEventTitle');
    }
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private rules: { [key: string]: TextRuleType } = {
    required: value => !!value || i18n.tc('portal.ruleInputRequired'),
  };

  private get jobPath(): object {
    return {
      name: 'job',
      params: {
        id: this.currentEventMetadata.job
          ? this.currentEventMetadata.job.id
          : 'not-exists',
      },
    };
  }

  private pageCreateOnEventIdInUrl(
    eventMetadata: ScheduledEventMetadataWithDetailForFront | null,
    path: string
  ) {
    if (eventMetadata && path === PAGE_PATH_BY_NAME.editEvent) {
      this.setDataForEditPage(eventMetadata);
    } else if (eventMetadata && path === PAGE_PATH_BY_NAME.copyEvent) {
      this.setDataForCopyPage(eventMetadata);
    } else if (eventMetadata && path === PAGE_PATH_BY_NAME.viewEvent) {
      this.setDataForViewPage(eventMetadata);
    } else if (path === PAGE_PATH_BY_NAME.createEvent) {
      this.redirectToCreatePage();
    } else {
      this.eventNotFound = true;
    }
  }

  private setDataForViewPage(
    eventMetadata: ScheduledEventMetadataWithDetailForFront
  ) {
    this.currentEventMetadata = R.clone(eventMetadata);
    this.dbEventMetadata = R.clone(eventMetadata);
    this.pageType = PageType.view;
    this.isJobSelected = true;
  }

  private setDataForEditPage(
    eventMetadata: ScheduledEventMetadataWithDetailForFront
  ) {
    this.currentEventMetadata = R.clone(eventMetadata);
    this.dbEventMetadata = R.clone(eventMetadata);
    this.pageType = PageType.edit;
    this.isJobSelected = true;
  }

  private setDataForCopyPage(
    eventMetadata: ScheduledEventMetadataWithDetailForFront
  ) {
    this.currentEventMetadata = R.clone(eventMetadata);
    this.dbEventMetadata = null;
    this.currentEventMetadata.id = uuidv4();
    this.currentEventMetadata.title =
      this.$t('jobScheduler.common.copy') + this.currentEventMetadata.title;
    this.pageType = PageType.copy;
    this.isJobSelected = true;
  }

  private redirectToCreatePage() {
    const movedFromEventCalendarPage = R.startsWith(
      '/eventCalendar',
      this.fromRoute
    );
    if (!movedFromEventCalendarPage) {
      this.currentEventMetadata.id = uuidv4();
      router.push({
        name: 'createEvent',
        params: { id: this.currentEventMetadata.id },
      });
    }
    this.pageType = PageType.create;
  }

  private pageCreateOnNoEventIdInUrl(path: string) {
    // in case there's no id in the url, for create page -> add an id, else show page-not-found
    if (path === PAGE_PATH_BY_NAME.createEvent) {
      this.currentEventMetadata.id = uuidv4();
      router.push({
        name: 'createEvent',
        params: { id: this.currentEventMetadata.id },
      });
      this.pageType = PageType.create;
    } else {
      this.eventNotFound = true;
    }
  }

  private filterJobByTitle(jobItem: JobIdAndTitle, searchWord: string) {
    return isJobTitleMatching(searchWord)(jobItem);
  }

  private onSelectedJobChange() {
    this.isJobSelected = Boolean(this.currentEventMetadata.job);
  }

  private changeHolidayExecutionType(triggerType: HolidayExecutionType) {
    this.currentEventMetadata.holidayExecutionType = triggerType;
  }

  private changeTriggerOnHolidays(triggerOnHolidays: TriggerOnHolidays) {
    this.currentEventMetadata.triggerOnHolidays = triggerOnHolidays;
  }

  private changeCustomHolidayLabels(holidayLabels: string[]) {
    this.currentEventMetadata.customHolidayLabels = holidayLabels;
  }

  private changeDateFrom(dateFrom: string) {
    this.currentEventMetadata.dateFrom = dateFrom;
  }

  private changeDateTo(dateTo: string) {
    this.currentEventMetadata.dateTo = dateTo;
  }

  private changeRepeatType(selectedRepeatType: RepeatType) {
    this.currentEventMetadata.repeatType = selectedRepeatType;
  }

  private changeWeekdays(selectedWeekdays: number[]) {
    this.currentEventMetadata.selectedWeekdays = selectedWeekdays;
  }

  private changeDays(selectedDays: number[]) {
    this.currentEventMetadata.selectedDays = selectedDays;
  }

  private changeExecutionTime(executionTime: string | null) {
    this.currentEventMetadata.executionTime = executionTime;
  }

  private redirectDate = (dateFrom: string | null) => {
    const [year, month, day] = dateFrom
      ? R.split('-', dateFrom)
      : R.split('-', newPortalDate(dayjs(), 'YYYY-MM-DD').toString());
    return [year, month, day];
  };

  private async doSave() {
    if (this.currentEventMetadata.repeatType === RepeatType.NoRepeat) {
      this.currentEventMetadata.dateTo = this.currentEventMetadata.dateFrom;
    }
    if (!this.currentEventMetadata.dateTo) {
      this.currentEventMetadata.dateTo = INFINITE_DATE;
    }
    if (this.pageType === PageType.create || this.pageType === PageType.copy) {
      if (this.currentEventMetadata.repeatType === RepeatType.NoRepeat) {
        this.currentEventMetadata.dateTo = this.currentEventMetadata.dateFrom;
      }
      this.userAction = UserAction.Create;
      await callCreateScheduledEventMetadata(
        this.currentEventMetadata,
        this.loginInfo
      );
    } else {
      this.userAction = UserAction.Edit;
      await this.doUpdateScheduledEventMetadata();
    }
    const isCurrentEventMetadataOrDbEventMetadataRelatedToToday = await isRelatedToToday(
      this.loginInfo,
      [this.currentEventMetadata, this.dbEventMetadata]
    );
    if (isCurrentEventMetadataOrDbEventMetadataRelatedToToday) {
      this.currentEventMetadata.rruleSet = getRRuleSet(
        getRRuleSetArgs(this.currentEventMetadata)
      );
      await changeTodayScheduledEvents(
        this.loginInfo,
        this.dbEventMetadata,
        this.currentEventMetadata,
        this.userAction,
        getTimezoneOffset()
      );
    }
    this.isSaved = true;
    const [year, month, day] = this.redirectDate(
      this.currentEventMetadata.dateFrom
    );
    router.push({
      name: 'eventCalendar',
      params: {
        period: 'month',
        year: year,
        month: month,
        day: day,
      },
    });
  }

  private async doUpdateScheduledEventMetadata() {
    if (isDateFromAfterToday(this.dbEventMetadata)) {
      await callUpdateScheduledEventMetadata(
        this.currentEventMetadata,
        this.loginInfo
      );
    } else {
      await this.endDbEventMetadataToday();
      await this.makeCurrentEventMetadataStartFromTomorrow();
    }
  }

  private async endDbEventMetadataToday() {
    const metadataEndingToday = endScheduleToday(this.dbEventMetadata);
    await callUpdateScheduledEventMetadata(metadataEndingToday, this.loginInfo);
  }

  private async makeCurrentEventMetadataStartFromTomorrow() {
    this.currentEventMetadata.id = uuidv4();
    if (
      this.dbEventMetadata &&
      this.dbEventMetadata.dateFrom === this.currentEventMetadata.dateFrom
    ) {
      this.currentEventMetadata = updateDateFromForCurrentEventMetadata(
        this.currentEventMetadata
      );
    }
    await callCreateScheduledEventMetadata(
      this.currentEventMetadata,
      this.loginInfo
    );
  }

  private onClickMoreActions(action: AvailableActions) {
    switch (action) {
      case AvailableActions.Abort:
        this.doAbort();
        break;
      default: {
        const inspector: never = action;
      }
    }
  }

  private async doAbort() {
    this.userAction = UserAction.Abort;
    this.showingConfirmationDialog = true;
  }

  private doCancel(): void {
    this.userAction = UserAction.Cancel;
    if (!this.doesAnyChangeExists()) {
      router.push(PAGE_PATH_BY_NAME.eventCalendar);
    } else {
      this.showingConfirmationDialog = true;
    }
  }

  private async onClickAbortInDialog() {
    this.showingConfirmationDialog = false;

    //update old metadata to end today
    const metadataEndingToday = endScheduleToday(this.currentEventMetadata);
    await callUpdateScheduledEventMetadata(metadataEndingToday, this.loginInfo);
    const isDbEventMetadataRelatedToToday = await isRelatedToToday(
      this.loginInfo,
      [this.dbEventMetadata]
    );
    this.isAborted = true;
    if (isDbEventMetadataRelatedToToday) {
      await changeTodayScheduledEvents(
        this.loginInfo,
        this.dbEventMetadata,
        this.currentEventMetadata,
        this.userAction,
        getTimezoneOffset()
      );
    }
    const [year, month, day] = this.redirectDate(
      this.currentEventMetadata.dateFrom
    );
    router.push({
      name: 'eventCalendar',
      params: {
        period: 'month',
        year: year,
        month: month,
        day: day,
      },
    });
  }

  private onClickOkInDialog() {
    this.showingConfirmationDialog = false;
    router.push(PAGE_PATH_BY_NAME.eventCalendar);
  }

  private onClickCancelInDialog() {
    this.showingConfirmationDialog = false;
  }

  private copyCurrentDataToDbData() {
    this.dbEventMetadata = R.clone(this.currentEventMetadata);
  }

  private doesAnyChangeExists() {
    return !R.equals(this.dbEventMetadata, this.currentEventMetadata);
  }

  private get isEditPage() {
    return this.pageType === PageType.edit;
  }

  private get isViewPage() {
    return this.pageType === PageType.view;
  }

  private get isAbortAction() {
    return this.userAction === UserAction.Abort;
  }

  private get dialogTitle() {
    return this.userAction === UserAction.Abort
      ? this.$t('jobScheduler.events.abortDialogTitle')
      : this.$t('common.discardDialogTitle');
  }

  private get confirmationMessage() {
    return this.userAction === UserAction.Abort
      ? this.$t('jobScheduler.events.abortConfirmMessage')
      : this.$t('common.discardConfirmMessage');
  }

  private get isEventDetailValid() {
    return Boolean(
      this.currentEventMetadata.title &&
        this.currentEventMetadata.job &&
        !this.hasErrorInScheduledSettingCard &&
        !this.hasErrorInHolidaySettingCard
    );
  }

  private get editedAt() {
    return this.currentEventMetadata.editedAt;
  }

  private validationErrorInScheduledSettingCard(doesErrorExists: boolean) {
    this.hasErrorInScheduledSettingCard = doesErrorExists;
  }

  private validationErrorInHolidaySettingCard(doesErrorExists: boolean) {
    this.hasErrorInHolidaySettingCard = doesErrorExists;
  }
}
